type BasicParams = Record<string, boolean | string | number | null | undefined>;

export function stringifyJsonParams(obj: BasicParams) {
  const stringified = JSON.stringify(obj, (_key, value) => {
    if (
      value === null ||
      value === undefined ||
      typeof value === "boolean" ||
      typeof value === "number"
    ) {
      return `${value}`;
    }
    return value as unknown;
  });
  return JSON.parse(stringified) as Record<string, string>;
}

export function makeUrlSearchParams(obj: BasicParams) {
  return new URLSearchParams(stringifyJsonParams(obj));
}

export function objectKeys<T extends object>(obj: T) {
  // like Object.keys, but with type safety
  return Object.keys(obj) as (keyof T)[];
}
